import { Provider } from '@angular/core';
import {
  DownloadFileUseCase,
  FuncCheckByUserAcctUseCase,
  GeneratePresignedUrlUseCase,
  GetEnumsUseCase,
  GetInputTypeMappingUseCase,
  GetMenuListUseCase,
  PresignedUrlUseCase,
} from '@application/use-cases';
import { CommonRepository } from '@domain/repositories';
import { CommonRepositoryImpl } from '../repositories';

export const COMMON_PROVIDERS: Provider[] = [
  {
    provide: CommonRepository,
    useClass: CommonRepositoryImpl,
  },
  {
    provide: GetEnumsUseCase,
    useFactory: (repo: CommonRepository) => new GetEnumsUseCase(repo),
    deps: [CommonRepository],
  },
  {
    provide: PresignedUrlUseCase,
    useFactory: (repo: CommonRepository) => new PresignedUrlUseCase(repo),
    deps: [CommonRepository],
  },
  {
    provide: GeneratePresignedUrlUseCase,
    useFactory: (repo: CommonRepository) =>
      new GeneratePresignedUrlUseCase(repo),
    deps: [CommonRepository],
  },
  {
    provide: DownloadFileUseCase,
    useFactory: (repo: CommonRepository) => new DownloadFileUseCase(repo),
    deps: [CommonRepository],
  },
  {
    provide: GetInputTypeMappingUseCase,
    useFactory: (repo: CommonRepository) =>
      new GetInputTypeMappingUseCase(repo),
    deps: [CommonRepository],
  },
  {
    provide: GetMenuListUseCase,
    useFactory: (repo: CommonRepository) => new GetMenuListUseCase(repo),
    deps: [CommonRepository],
  },
  {
    provide: FuncCheckByUserAcctUseCase,
    useFactory: (repo: CommonRepository) =>
      new FuncCheckByUserAcctUseCase(repo),
    deps: [CommonRepository],
  },
];
